import { render, staticRenderFns } from "./module-batch-operate.vue?vue&type=template&id=9ba21178&scoped=true"
import script from "./module-batch-operate.vue?vue&type=script&lang=js"
export * from "./module-batch-operate.vue?vue&type=script&lang=js"
import style0 from "./module-batch-operate.vue?vue&type=style&index=0&id=9ba21178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba21178",
  null
  
)

export default component.exports